// Admin API client — /admin/channel-console/* (mirrors the API's channel-console aggregate).

import type {
  ApiEnvelope as ChannelConsoleEnvelope,
  ChannelConsoleWebsiteData,
  ChannelConsoleProductData,
  ChannelConsoleLinkedInData,
} from '@/pages/channel-console/types';
import { client } from './transport';

export const channelConsoleApi = {
  // A7Y-3776 — Channel Console Website module. Serves the last successful
  // nightly/on-demand pull from BigQuery; the reliability shell (A7Y-3777)
  // retired the per-day KV cache and `?force=1`.
  getChannelConsoleWebsite: () =>
    client.get<ChannelConsoleEnvelope<ChannelConsoleWebsiteData>>('/channel-console/website'),
  // A7Y-3777 — runs the same on-demand pull core as the nightly job and
  // returns the refreshed payload.
  refreshChannelConsoleWebsite: () =>
    client.post<ChannelConsoleEnvelope<ChannelConsoleWebsiteData>>(
      '/channel-console/website/refresh',
      {}
    ),
  // A7Y-3778 — Channel Console Product module (funnel + revenue). GET does no
  // upstream work; revenue and ledger stage counts are live on every read.
  getChannelConsoleProduct: () =>
    client.get<ChannelConsoleEnvelope<ChannelConsoleProductData>>('/channel-console/product'),
  // Mirrors the website refresh: on-demand Mixpanel pull only, same core as
  // the nightly job.
  refreshChannelConsoleProduct: () =>
    client.post<ChannelConsoleEnvelope<ChannelConsoleProductData>>(
      '/channel-console/product/refresh',
      {}
    ),
  // A7Y-3779 — Channel Console LinkedIn module. GET reads the newest stored
  // snapshot and does no upstream work; refresh captures a fresh one.
  getChannelConsoleLinkedIn: () =>
    client.get<ChannelConsoleEnvelope<ChannelConsoleLinkedInData>>('/channel-console/linkedin'),
  refreshChannelConsoleLinkedIn: () =>
    client.post<ChannelConsoleEnvelope<ChannelConsoleLinkedInData>>(
      '/channel-console/linkedin/refresh',
      {}
    ),
};
